import React, { useState } from 'react';
import { NotebookCell } from '../../services/notebook-service/src/types';

interface NotebookCellProps {
  cell: NotebookCell;
  userRole: string;
  onRun: () => void;
  onDelete: () => void;
}

export const NotebookCellComponent: React.FC<NotebookCellProps> = ({ cell, userRole, onRun, onDelete }) => {
  const [content, setContent] = useState(cell.content);
  const [editing, setEditing] = useState(false);

  const handleSave = async () => {
    // TODO: Save cell content to backend
    setEditing(false);
  };

  return (
    <div className={`notebook-cell notebook-cell-${cell.type}`}>
      <div className="cell-header">
        <span>{cell.type.toUpperCase()} Cell</span>
        {userRole === 'editor' && (
          <>
            <button onClick={() => setEditing(!editing)}>{editing ? 'Cancel' : 'Edit'}</button>
            <button onClick={onDelete}>Delete</button>
          </>
        )}
        <button onClick={onRun}>Run</button>
      </div>
      <div className="cell-body">
        {editing ? (
          <textarea value={content} onChange={e => setContent(e.target.value)} />
        ) : (
          cell.type === 'markdown' ? (
            <div className="markdown-preview">{content}</div> // TODO: Render markdown
          ) : (
            <pre>{content}</pre>
          )
        )}
      </div>
      {cell.output && (
        <div className="cell-output">
          <strong>Output:</strong>
          <pre>{JSON.stringify(cell.output, null, 2)}</pre>
        </div>
      )}
      {cell.error && (
        <div className="cell-error">Error: {cell.error}</div>
      )}
      {editing && (
        <button onClick={handleSave}>Save</button>
      )}
    </div>
  );
}; 